<template>
  <v-container>
    <v-row>
      <v-col>
        <v-dialog
          v-model="dialog"
          width="450"
          persistent
        >
          <v-card>
            <div class="pa-4">
              <v-card-title>
                <span class="error--text">Error al reeestablecer contraseña</span>
              </v-card-title>
              <v-card-text class="pb-3">
                <v-icon color="error" class="mr-2" small>mdi-alert-circle</v-icon><span>El token ingresado es invalido o ya expiro.</span>
                <div class="d-flex">
                  <BaseMyButton
                    class="mt-4 mx-auto"
                    borderRadius="100"
                    :to="{ name: 'home' }"
                  >
                    Volver a inicio
                  </BaseMyButton>
                </div>
              </v-card-text>
            </div>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  props: {
    token: {
      type: String,
    },
  },
  data() {
    return {
      dialog: true,
    }
  },
}
</script>

<style>

</style>